module.exports = new __parcel__URL__("shop_item_info_button.9d105054.png").toString();